module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qnerv3-08b1d4ecfc13c7a409ad1420d98a6408.jpg";